// Import LOVs from centralized location
import {
  changeOptions,
  indTypeOptions,
  protocolTypeOptions,
  requestTypeOptions
} from "./Lovs";

export const handleAncillaryUndo = (field, index, defaultValues, setValue) => {
  let sourceObj = {};
  if (field.psOpenAncillaryId) {
    sourceObj = defaultValues?.protSetupAncillaryStudies?.find(
      (obj) => obj.psOpenAncillaryId === field.psOpenAncillaryId
    );
  }
  const {
    groupProtocolNumber = "",
    stepNumber = "",
    mandatory = "MANDATORY"
  } = sourceObj;

  setValue(
    `protSetupAncillaryStudies.${index}.groupProtocolNumber`,
    groupProtocolNumber,
    { shouldValidate: true,
      shouldDirty: true
     }
  );
  setValue(`protSetupAncillaryStudies.${index}.stepNumber`, stepNumber, {
    shouldValidate: true,
    shouldDirty: true
  });
  setValue(`protSetupAncillaryStudies.${index}.mandatory`, mandatory, {
    shouldValidate: true,
    shouldDirty: true
  });
};

export const handleIrocUndo = (field, index, defaultValues, setValue) => {
  let sourceObj = {};
  if (field?.psOpenIrocId) {
    sourceObj = defaultValues?.protSetupIrocDetails?.find(
      (obj) => obj.psOpenIrocId === field.psOpenIrocId
    );
  }
  const { type = "", requirement = "MANDATORY" } = sourceObj;

  setValue(`protSetupIrocDetails.${index}.type`, type, {
    shouldValidate: true,
    shouldDirty: true
  });
  setValue(`protSetupIrocDetails.${index}.requirement`, requirement, {
    shouldValidate: true,
    shouldDirty: true
  });
};

export const handleStepUndo = (
  field,
  index,
  defaultValues,
  setValue,
  getValues
) => {
  let sourceObj = {};
  if (field?.psOpenStepId) {
    sourceObj = defaultValues?.protSetupStepDetails?.find(
      (obj) => obj.psOpenStepId === field.psOpenStepId
    );
  }
  const {
    psOpenStepId  = "",
    required = "",
    publicFormIds = "",
    crfVersionNum = "",
    stepNumber = "",
    stepDescription = "",
    registrationType = "",
    initialization = "",
    transferEcData = "",
    markForDownload = true
  } = sourceObj;

  const currentArray = getValues("protSetupStepDetails") || [];
  currentArray[index] = {
    required,
    publicFormIds,
    crfVersionNum,
    stepNumber,
    stepDescription,
    registrationType,
    initialization,
    transferEcData,
    markForDownload,
    psOpenStepId
  };
  setValue("protSetupStepDetails", currentArray, {
    shouldValidate: true,
    shouldDirty: true
  });
};

export const regTypetoolTip = () => {
  return `i. Patient forms enroll patient participants. \nii. Non-Patient Providers forms enroll physicians, physician assistants, and nurse practitioners. \niii. Non-Patient Other Professional Discipline forms enroll other professionals involved with the care of patients. \niv. Non-Patient Caregiver forms enroll family and other non-medical professionals involved with patient care. \nv. Non-Patient Practices forms enroll the sites enrolling non-patients. \nvi. Non-Patient Other forms enroll all other non-patient entities not defined in other existing form types.`;
};

export const constraintMappings = {
  PROTOCOL_SETUP_OPEN_ANCILLARY_STUDIES:
    "Ancillary study has duplicate records.",
  PROTOCOL_SETUP_OPEN_IROC_DETAILS: "IROC credentialing has duplicate records.",
  PROTOCOL_SETUP_OPEN_STEP_DETAILS: "Step information has duplicate records.",
  PROTOCOL_SETUP_REG_PSR: "PSR has duplicate records."
};

// Re-export for backward compatibility
export {
  changeOptions,
  indTypeOptions,
  protocolTypeOptions,
  requestTypeOptions
};

export const formatListOfChanges = (listOfChanges) => {
  return changeOptions?.reduce((acc, option) => {
    acc[option.value] = listOfChanges.includes(option.value);
    return acc;
  }, {});
};

export const extractListOfChanges = (mainObject) => {
  return changeOptions
    ?.map((option) => option.value)
    ?.filter((changeType) => mainObject?.[changeType] === true);
};

export const extractContactsByType = (mainObject, contactType) => {
  return mainObject?.protSetupContacts
    ?.filter((contact) => contact.contactType === contactType)
    ?.map((contact) => contact.perId);
};

export const tabNames = {
  PROTOCOL_INFORMATION: "Protocol Information",
  OPEN_SETUP: "OPEN Setup",
  RAVE_SETUP: "Rave Setup",
  SIGNOFF_SUBMITTED: "Signoff: Submitted",
  SIGNOFF_UAT_SETUP: "Signoff: UAT Setup",
  SIGNOFF_GROUP_TESTING: "Signoff: Group Testing",
  SIGNOFF_CTSU_TESTING: "Signoff: CTSU Testing",
  SIGNOFF_PENDING_SIGNOFF: "Signoff: Pending Signoff",
  SIGNOFF_COMPLETED: "Signoff: Completed"
};
